<template>
  <div class="content">
    <div class="logo-container">森威拍卖</div>

    <div class="header-container">
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        background-color="#545c64"
        text-color="#fff"
        router
        active-text-color="#ffd04b"
      >
        <template v-for="item in leftMenu" :key="item.id">
          <MenuItem :data="item"> </MenuItem>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MenuItem from "./menu.vue";

export default {
  components: {
    MenuItem,
  },
  mounted() {
    // console.log('加载Aside.vue');
  },
  setup() {
    //所有菜单数据
    let menuObj = [];
    return {
      menuObj,
    };
  },
  computed: {
    ...mapState(["leftMenu"]),
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;

  .logo-container {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #343a52;
    font-weight: bold;
    font-size: 20px;
  }

  .logo {
    display: block;
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }

  .el-menu {
    height: 100%;
    border: 0 !important;

    :deep(.el-menu-item-group__title) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  // 左侧菜单
  .header-container {
    height: calc(100% - 100px);

    :deep(.el-menu) {
      background: #343a52 !important;
      .el-menu-item.is-active {
        color: #fff;
        background-color: #191d2c !important;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 2px;
          height: 100%;
          background-color: #fff;
        }
      }
    }
  }
}

.el-sub-menu__title {
  padding-left: 10px;
}
</style>